import svgUrl from "ni:svgr;ILPhVzJIhnuN9BFyOVY0DYFBTKzPrCUa17JG26-S7Pw";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiBlankTableSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2 2h11v3H2z" opacity={0.08} /><path fill="currentColor" fillRule="evenodd" d="M2 2h11v3H2V2Zm7 4H6v3h3V6Zm0 4H6v3h3v-3Zm1 3h3v-3h-3v3Zm0-4V6h3v3h-3ZM2 6v3h3V6H2Zm0 7v-3h3v3H2ZM1 2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiBlankTableSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiBlankTableSIcon)";
}